//Set dark as initialColorModeName
export default 'light'